import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
export const frontmatter = {
  "title": "Lernpfade",
  "lead": "Trotz der Tatsache, dass die meisten Kinder heutzutage viele Jahre in der Schule verbringen, verlassen sie diese häufig ohne grundlegende Lese- und Mathematikkenntnisse. Lernverläufe veranschaulichen, wie viel Wissen ein Kind im Laufe seiner Schulzeit erwirbt. Sie können dazu beitragen, den Prozess zu analysieren, der zu geringen Lernergebnissen führt, den optimalen Zeitpunkt und die geeigneten Methoden für Interventionen zu bestimmen und die potenziellen Auswirkungen verschiedener bildungspolitischer Maßnahmen auf dieses dringende Problem zu simulieren."
};
function _createMdxContent(props) {
  const _components = {
    a: "a",
    blockquote: "blockquote",
    h2: "h2",
    h3: "h3",
    li: "li",
    p: "p",
    strong: "strong",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  }, {Explorer, Figure, HighlightByIndex, IndicatorReference, RelatedMaterial, ScrollyArea, ScrollySection, ScrollyStep, ScrollySticky, SimulationsTab, TrajectoriesTab} = _components;
  if (!Explorer) _missingMdxReference("Explorer", true);
  if (!Figure) _missingMdxReference("Figure", true);
  if (!HighlightByIndex) _missingMdxReference("HighlightByIndex", true);
  if (!IndicatorReference) _missingMdxReference("IndicatorReference", true);
  if (!RelatedMaterial) _missingMdxReference("RelatedMaterial", true);
  if (!ScrollyArea) _missingMdxReference("ScrollyArea", true);
  if (!ScrollySection) _missingMdxReference("ScrollySection", true);
  if (!ScrollyStep) _missingMdxReference("ScrollyStep", true);
  if (!ScrollySticky) _missingMdxReference("ScrollySticky", true);
  if (!SimulationsTab) _missingMdxReference("SimulationsTab", true);
  if (!TrajectoriesTab) _missingMdxReference("TrajectoriesTab", true);
  return _jsxs(_Fragment, {
    children: [_jsx(Figure, {
      id: "HERO_LEARNING"
    }), "\n", _jsxs(_components.blockquote, {
      children: ["\n", _jsx(_components.p, {
        children: "Lernpfade verdeutlichen, wie viele Jahre oder Schulstufen ein Kind benötigt, um grundlegende Fähigkeiten zu erlangen. Da diese Pfade das Lerntempo innerhalb des Bildungssystems abbilden, können sie aufzeigen, wie viele Kinder Schwierigkeiten haben, grundlegende Fähigkeiten zu erlernen. Zudem bieten sie Orientierungspunkte, um den richtigen Zeitpunkt und die effektivsten Ansätze für Interventionen zu identifizieren und die Auswirkungen verschiedener politischer Maßnahmen auf die Herausforderung geringer Lernleistungen zu bewerten."
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "was-lässt-sich-aus-lernpfaden-ablesen",
      children: "Was lässt sich aus Lernpfaden ablesen?"
    }), "\n", _jsx(_components.p, {
      children: "Im Idealfall verlaufen Lernpfade steil. Allzu oft sehen wir jedoch flache Lernkurven, die auf ein langsames Lerntempo hindeuten. Ein langsamer Start kann langfristige Folgen haben. Wenn Kinder zurückfallen, wird im Lehrplan häufig zu anspruchsvolleren Themen übergegangen, für die ihnen die notwendigen Fähigkeiten fehlen."
    }), "\n", _jsx(_components.p, {
      children: "**Die Entwicklung in vielen Ländern zeigt, dass das Lerntempo viel zu langsam ist, und zwar von Beginn der Schulzeit an In den Klassen 1 und 2, in denen die globalen Ziele und viele nationale Lehrpläne davon ausgehen, dass die Kinder das Lesen erlernen, gelingt dies nur einer kleinen Minderheit der Kinder."
    }), "\n", _jsx(IndicatorReference, {
      id: "4.1.1",
      label: "4.1.1a",
      children: _jsxs(_components.p, {
        children: ["Diese Fähigkeiten, die in der sechsten Runde der UNICEF Multiple Indicator Cluster Surveys (MICS6) erfasst werden, sind grundlegende Voraussetzungen für späteres Lernen. Hier wird geprüft, ob die Kinder eine einfache Geschichte mit 70 Wörtern laut vorlesen können (z. B. \"Manh ist in der zweiten Klasse.\") und in der Lage sind, fünf einfache Fragen dazu zu beantworten (z. B. \"In welche Klasse geht Manh?\"). Diese grundlegenden Fähigkeiten liegen in der Regel unter dem Mindestniveau, das im ", _jsx(_components.a, {
          href: "https://sdgs.un.org/goals/goal4",
          children: "Globalindikator 4.1.1 a des Sustainable Development Goals (SDG)"
        }), " festgelegt ist. Die berechneten Pfade überschätzen somit die Fortschritte bei der Erreichung des Unterziels SDG 4.1.1 a, bieten jedoch dennoch nützliche Schätzungen, um das Lerntempo zu verdeutlichen."]
      })
    }), "\n", _jsxs(ScrollyArea, {
      children: [_jsx(ScrollySticky, {
        children: _jsx(Figure, {
          id: "TRAJECTORIES_CURRENT"
        })
      }), _jsx(ScrollySection, {
        id: "HIGHLIGHT_VIETNAM",
        children: _jsxs(_components.p, {
          children: [_jsx(HighlightByIndex, {
            index: "2",
            children: "Vietnam"
          }), " ist ein gutes Beispiel für\neine relativ leistungsstarke Entwicklung des Landes. In den ersten Schulklassen\nlernen die meisten Kinder in Vietnam grundlegende Lesefertigkeiten."]
        })
      }), _jsx(ScrollySection, {
        id: "LMIC_GRADE_3",
        children: _jsxs(_components.p, {
          children: ["Die Lernkurve in vielen anderen", " ", "\n", _jsx(HighlightByIndex, {
            index: "4",
            children: "Ländern mit niedrigem und niedrigem bis mittlerem Einkommen"
          }), " ", "\nist viel flacher. Nur eines von vier Kindern in einem durchschnittlichen Land\nlernt derzeit bis zur 3. Klasse grundlegende Lesefertigkeiten."]
        })
      }), _jsx(ScrollySection, {
        id: "LMIC_GRADE_6",
        children: _jsxs(_components.p, {
          children: ["Das niedrige Lernniveau zieht sich durch die gesamte Schulzeit hindurch. Etwas mehr als die Hälfte der\nSchüler der Klasse 6 in ", " ", "\n", _jsx(HighlightByIndex, {
            index: "4",
            children: "Länder mit niedrigem und niedrigem bis mittlerem Einkommen"
          }), " ", "\nim Datensatz haben eine Lesekompetenz erreicht, die typischerweise den Klassen 2-3 entspricht\nentspricht."]
        })
      }), _jsx(ScrollySection, {
        id: "DIFFERENCE_TRAJECTORIES",
        children: _jsx(_components.p, {
          children: "Hinter der durchschnittlichen Entwicklung verbergen sich jedoch Unterschiede zwischen den einzelnen Ländern. Irgendwo\nzwischen 3 Prozent und 76 Prozent der Kinder in Ländern mit niedrigem und niedrigem bis mittlerem Einkommen\nim Datensatz können bereits in der 3. Klasse lesen. Dies zeigt,\ndass Länder, die sich für die Verbesserung der Grundbildung einsetzen,\nauch bei relativ niedrigem Volkseinkommen Erfolge erzielen können."
        })
      }), _jsx(ScrollyStep, {
        id: "default"
      })]
    }), "\n", _jsx(_components.p, {
      children: "Für ein Land, das das Problem des niedrigen Bildungsniveaus angehen möchte, ergeben sich daraus die folgenden politischen Konsequenzen:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: "Messung und Priorisierung grundlegender Fähigkeiten, beginnend in den unteren Klassenstufen."
      }), "\n", _jsx(_components.li, {
        children: "Anpassung des Unterrichts an das tatsächliche Lerntempo der Kinder. Dies kann auf verschiedene Weise erfolgen, zum Beispiel durch die Festlegung klarer Lernziele, die sich auf die Grundlagen des Lernens konzentrieren, durch die Anpassung des Lehrplantempos und durch die Unterstützung der Lehrkräfte, damit sie den aktuellen Lernstand der Kinder erkennen und ihren Unterricht entsprechend anpassen können."
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "politiksimulationen-zugang-und-lernen",
      children: "Politiksimulationen: Zugang und Lernen"
    }), "\n", _jsx(_components.p, {
      children: "Durch Lernverläufe können wir die potenziellen Auswirkungen verschiedener Maßnahmen miteinander vergleichen. Hier simulieren wir die Auswirkungen von Maßnahmen zur Verbesserung des Zugangs und des Lernens. Zugangsorientierte Maßnahmen haben das Ziel, die Anzahl der Schuljahre, die Kinder absolvieren, zu erhöhen. Dazu zählen Maßnahmen wie kostenlose Grund- und Sekundarschulbildung, der Ausbau von Schulen, automatische Förderungen und andere Initiativen, die sich vor allem auf die Einschulung oder den schulischen Erfolg konzentrieren. Lernorientierte Maßnahmen haben das Ziel, dass Kinder in jeder Schulstufe mehr lernen. Beispiele für solche Maßnahmen sind die Festlegung und Messung von Fortschritten anhand klarer Lernziele, die Anpassung des Unterrichts an das Lerntempo der Kinder und die Förderung eines effektiven Unterrichts."
    }), "\n", _jsxs(_components.p, {
      children: ["Jedes Kind sollte Zugang zur Schule haben, und die Einschulung ist ein notwendiger erster Schritt auf dem Weg zu einem umfassenden Bildungsweg. Diese Simulationen zeigen jedoch, dass weitere ", _jsx(HighlightByIndex, {
        index: "2",
        children: "weitere Verbesserungen im Zugang"
      }), " allein wenig dazu beitragen werden, das Lernen zu fördern. Im Gegensatz dazu gibt es große potenzielle Fortschritte, die durch ", _jsx(HighlightByIndex, {
        index: "3",
        children: "steigendes Lernen pro Klasse"
      }), " um das Tempo der leistungsstärkeren Länder mit niedrigem und niedrigem bis mittlerem Einkommen zu erreichen."]
    }), "\n", _jsxs(ScrollyArea, {
      children: [_jsx(ScrollySticky, {
        children: _jsx(Figure, {
          id: "TRAJECTORIES_SIMULATION_LMIC"
        })
      }), _jsx(ScrollySection, {
        id: "COMPARISON",
        children: _jsx(_components.p, {
          children: "Der Leistungsunterschied zwischen Ländern mit niedrigem und hohem Leistungsniveau\nwird sowohl durch einen besseren Zugang zur Schule als auch insbesondere durch Maßnahmen beeinflusst,\ndie es den Kindern ermöglichen, in jeder Klasse mehr zu lernen."
        })
      }), _jsx(ScrollySection, {
        id: "FADED",
        children: _jsx(_components.p, {
          children: "Diese Simulationen veranschaulichen die Lernverläufe in Abhängigkeit vom Alter. Sie umfassen sowohl Kinder in\nals auch außerhalb der Schule. Da Kinder, die nicht zur Schule gehen, in der Regel weniger lernen,\nsind diese Lernverläufe flacher als jene, die nach Klassenstufen betrachtet werden."
        })
      }), _jsx(ScrollySection, {
        id: "CURRENT",
        children: _jsxs(_components.p, {
          children: ["Der Durchschnittswert für fünf leistungsschwache", " ", "\n", _jsx(HighlightByIndex, {
            index: "4",
            children: "Länder mit niedrigem und niedrigem bis mittlerem Einkommen"
          }), " ", "\nbeträgt bei den 9-Jährigen allerdings nur 8\nProzent."]
        })
      }), _jsx(ScrollySection, {
        id: "SIMULATION_ACCESS",
        children: _jsxs(_components.p, {
          children: ["Die ", _jsx(HighlightByIndex, {
            index: "2",
            children: "Zugangssimulation"
          }), " ", "\nentspricht in etwa dem, was passieren würde, wenn alle Kinder in der Schule wären. Dies wird erreicht,\nindem geschätzt wird, was geschehen würde, wenn alle Kinder, die nie eine Schule besucht haben\ndiese abgebrochen haben, stattdessen denselben Notendurchschnitt\nund dasselbe Lernniveau wie ihre gleichaltrigen Mitschüler erreichen würden. In denselben fünf\nleistungsschwachen Ländern würde dies laut den Simulationen\ndie Anzahl der 9-Jährigen, die lesen können, um 1 Prozentpunkt erhöhen."]
        })
      }), _jsx(ScrollySection, {
        id: "SIMULATION_LEARNING",
        children: _jsxs(_components.p, {
          children: ["Würden die 9-Jährigen in diesen Ländern weiterhin die gleiche Klassenstufe erreichen wie\nsie es aktuell tun, stattdessen jedoch", " ", "\n", _jsx(HighlightByIndex, {
            index: "3",
            children: "so viel pro Klasse lernen"
          }), "wie\nwie Kinder in den fünf leistungsstärksten Ländern mit niedrigem und niedrigem bis mittlerem Einkommen,\ndann könnten 43 Prozent von ihnen lesen, was einem Anstieg von\n35 Prozentpunkten ausmacht."]
        })
      }), _jsx(ScrollyStep, {
        id: "default"
      })]
    }), "\n", _jsx(_components.h2, {
      id: "politiksimulationen-gleichheit",
      children: "Politiksimulationen: Gleichheit"
    }), "\n", _jsx(_components.p, {
      children: "Lernpfade sind auch ein wirkungsvolles Werkzeug, um Lernunterschiede zwischen verschiedenen Gruppen innerhalb eines Landes zu analysieren und besser zu verstehen. Hier vergleichen wir das Lernniveau von wohlhabenden und benachteiligten Gruppen und simulieren die Auswirkungen von Maßnahmen, die darauf abzielen, die Ungleichheit zwischen ihnen zu verringern."
    }), "\n", _jsxs(_components.p, {
      children: ["In den im Datensatz enthaltenen Ländern mit niedrigem und niedrigem bis mittlerem Einkommen besuchen Kinder aus wohlhabenden Familien (oberste 20 % des Vermögens) durchschnittlich häufiger die Schule und erzielen in jeder Klasse größere Lernfortschritte als Kinder aus ärmeren Familien (unterste 20 % des Vermögens). Die ", _jsx(HighlightByIndex, {
        index: "2",
        children: "Simulation des gleichberechtigten Zugangs"
      }), " zeigt, was passieren würde, wenn Kinder aus armen Familien genauso viel Schulbildung erhalten wie die aus reichen Familien, während die ", _jsx(HighlightByIndex, {
        index: "3",
        children: "simulation des gleichen Lernens"
      }), " zeigt, was passieren könnte, wenn Kinder aus armen Familien genauso viel pro Klasse lernen würden wie die aus reichen Familien. In beiden Szenarien, insbesondere jedoch in der Simulation des gleichberechtigten Lernens, würde die Ungleichheit reduziert werden."]
    }), "\n", _jsx(_components.p, {
      children: "**Jedoch erhalten auch die Kinder der Reichen keine gute Ausbildung. Fast die Hälfte der Kinder aus wohlhabenden Familien erwirbt keine grundlegenden Lesefähigkeiten, was die mögliche Wirkung von Maßnahmen zur Förderung der Chancengleichheit einschränkt. Simulationen zur Gleichstellung von Jungen und Mädchen oder von Stadt- und Landkindern zeigen noch geringere Fortschritte."
    }), "\n", _jsxs(_components.p, {
      children: ["Für ein Land, das das Problem des niedrigen Bildungsniveaus angehen möchte, lautet die politische Schlussfolgerung, dass die Schließung der Lücken zwischen Gruppen innerhalb des Landes nur ein Teil der Lösung ist. ", _jsx(_components.strong, {
        children: "Eine ebenso dringende Herausforderung besteht darin, systemische Veränderungen vorzunehmen, die das Lernen für alle Kinder – unabhängig von ihrem sozialen Hintergrund, Geschlecht oder Wohnort – verbessern, um den Übergang von einem System mit niedriger Leistung zu einem System mit hoher Leistung zu ermöglichen."
      })]
    }), "\n", _jsxs(ScrollyArea, {
      children: [_jsx(ScrollySticky, {
        children: _jsx(Figure, {
          id: "TRAJECTORIES_SIMULATION_EQUALITY"
        })
      }), _jsx(ScrollySection, {
        id: "CURRENT",
        children: _jsxs(_components.p, {
          children: ["Kinder aus", _jsx(HighlightByIndex, {
            index: "4",
            children: "ärmeren Familien"
          }), " sind\nauf einem schlechteren Lernpfad als die aus reichen Familien. Im Durchschnitt\nder 23 Länder mit niedrigem und niedrigem bis mittlerem Einkommen verfügen nur 19 Prozent\nder Kinder aus armen Familien im Alter von 9 Jahren über grundlegende Lesefähigkeiten."]
        })
      }), _jsx(ScrollySection, {
        id: "SIMULATION_ACCESS",
        children: _jsxs(_components.p, {
          children: ["Die ", _jsx(HighlightByIndex, {
            index: "2",
            children: "erste Simulation"
          }), " zeigt,\nwas passieren könnte, wenn Kinder aus armen Familien genauso viel Schulbildung bekämen wie\nkinder aus wohlhabenden Familien (in Bezug auf die erreichten Schulnoten nach Alter). Im Durchschnitt\nüber 23 Länder hinweg würde dies die grundlegenden Lesefähigkeiten von 9-Jährigen\nnur um 4 Prozentpunkte erhöhen."]
        })
      }), _jsx(ScrollySection, {
        id: "SIMULATION_LEARNING",
        children: _jsxs(_components.p, {
          children: ["Die ", _jsx(HighlightByIndex, {
            index: "3",
            children: "zweite Simulation"
          }), " zeigt,\nwas passieren könnte, wenn Kinder aus armen Familien ihren derzeitigen Status\ndes Schulniveaus beibehalten (d. h. dieselbe Schulstufe wie heute), sondern\nso viel pro Klasse wie Kinder aus reichen Familien lernen. Dies würde potenziell\nihre grundlegenden Lesefähigkeiten im Alter von 9 Jahren um 17 Prozentpunkte\nverbessern."]
        })
      }), _jsx(ScrollySection, {
        id: "COMPARISON",
        children: _jsx(_components.p, {
          children: "Wenn Kinder aus armen Familien genauso viel zur Schule gingen und ebenso viel lernten\nwie Kinder aus wohlhabenden Familien – also wenn sie denselben Bildungsweg wie die Reichen einschlagen könnten –,\nwürde sich ihre grundlegenden Lesefähigkeiten\num 29 Prozentpunkte erhöhen."
        })
      }), _jsx(ScrollySection, {
        id: "COMPARISON_GROUP",
        children: _jsx(_components.p, {
          children: "Allerdings verblieben auch dann immer noch fast die Hälfte der Kinder ohne grundlegende\nLesekompetenz. Selbst die Kinder reicher Familien erhalten in vielen Ländern\nkeine gute Bildung."
        })
      }), _jsx(ScrollyStep, {
        id: "default"
      })]
    }), "\n", _jsx(_components.h2, {
      id: "entwickeln-sie-eigene-lernpfade-und-simulieren-sie-politische-maßnahmen",
      children: "Entwickeln Sie eigene Lernpfade und simulieren Sie politische Maßnahmen."
    }), "\n", _jsx(_components.p, {
      children: "Im Folgenden finden Sie ein Tool, mit dem Sie eigene Lernpfade erstellen und politische Simulationen durchführen können. Sie können Daten aus verschiedenen Ländern sowohl für grundlegende Lese- als auch Mathematikfähigkeiten analysieren."
    }), "\n", _jsxs(_components.p, {
      children: ["Zur Erinnerung: Die Lesekompetenz wird gemessen, indem überprüft wird, ob die Kinder eine einfache Geschichte mit 70 Wörtern laut vorlesen und fünf einfache Fragen zu dieser Geschichte beantworten können. Die mathematischen Fähigkeiten werden in vier Bereichen (Zahlenerkennung, Zahlenunterscheidung, einfache Addition und Zahlenmuster) durch 21 einfache Fragen erfasst. Ein Kind beherrscht diese Grundfertigkeiten im Lesen und Rechnen, wenn es alle Fragen korrekt beantwortet hat. In der Regel handelt es sich dabei um Fähigkeiten aus der 2. oder 3. Klasse, die unter dem Mindestniveau liegen, und im ", _jsx(_components.a, {
        href: "https://sdgs.un.org/goals/goal4",
        children: "SDG-Gesamtindikator 4.1.1a"
      }), "festgelegt sind."]
    }), "\n", _jsxs(Explorer, {
      children: [_jsx(TrajectoriesTab, {
        children: _jsx(_components.p, {
          children: "Lernpfade sind von Kontext zu Kontext sehr unterschiedlich. Mit diesem Tool können Sie\ndie für Sie wichtigsten Pfade erstellen, vergleichen und exportieren.\nSie können die Entwicklung der verschiedenen Länder visualisieren und vergleichen, oder\nden Lernpfad von Gruppen innerhalb eines Landes erstellen und vergleichen."
        })
      }), _jsx(SimulationsTab, {
        children: _jsx(_components.p, {
          children: "Mit diesen Tools können Sie Politiksimulationen durchführen und die Ergebnisse analysieren, um\npolitische Prioritäten zu formulieren. Sie können Politiksimulationen auf nationaler Ebene durchführen,\num die Auswirkungen einer allgemeinen Schulbildung abzuschätzen\nund den Lernstand pro Klasse mit dem eines Vergleichslandes zu vergleichen. Sie können\nPolitiksimulationen für verschiedene Gruppen innerhalb eines Landes durchführen,\num zu simulieren, welche Auswirkungen es hätte, wenn zwei Bevölkerungsgruppen\ndie gleichen Schulabschluss- und Lernquoten erreichen würden."
        })
      })]
    }), "\n", _jsx(_components.h2, {
      id: "schlussfolgerung",
      children: "Schlussfolgerung"
    }), "\n", _jsx(_components.p, {
      children: "Lernpfade verdeutlichen, wie schnell Kinder grundlegende Lernfähigkeiten entwickeln. Sie sind ein wichtiges Instrument, um die Öffentlichkeit für schlechte Lernergebnisse zu sensibilisieren und den politischen Entscheidungsträgern bei der Planung von Maßnahmen zu helfen."
    }), "\n", _jsx(_components.h3, {
      id: "danksagungen",
      children: "Danksagungen"
    }), "\n", _jsxs(_components.p, {
      children: ["Der Inhalt dieser Webseite wurde vom ", _jsx(_components.a, {
        href: "http://riseprogramme.org/",
        children: "RISE (Research on Improving Systems of Education) Programme"
      }), "erstellt – dem groß angelegten Forschungsprogramm für Bildungssysteme, das mit Mitteln des ", _jsx(_components.a, {
        href: "https://www.gov.uk/government/organisations/foreign-commonwealth-development-office",
        children: "United Kingdom's Foreign, Commonwealth and Development Office (FCDO)"
      }), ", des ", _jsx(_components.a, {
        href: "http://dfat.gov.au",
        children: "Australian Government's Department of Foreign Affairs and Trade (DFAT)"
      }), "und der ", _jsx(_components.a, {
        href: "https://www.gatesfoundation.org",
        children: "Bill and Melinda Gates Foundation"
      }), "unterstützt wird. Das Programm wird im Rahmen einer Partnerschaft zwischen ", _jsx(_components.a, {
        href: "https://www.opml.co.uk",
        children: "Oxford Policy Management"
      }), "und der ", _jsx(_components.a, {
        href: "http://bsg.ox.ac.uk",
        children: "Blavatnik School of Government an der University of Oxford"
      }), "verwaltet und durchgeführt."]
    }), "\n", _jsx(RelatedMaterial, {
      children: _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://riseprogramme.org/tools/learning-trajectories",
            children: "Learning trajectories resources – RISE"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://data.unicef.org/resources/are-children-really-learning-foundational-skills-report/",
            children: "Are Children Really Learning? Exploring foundational skills in the midst of a learning crisis – UNICEF 2022"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://www.sciencedirect.com/journal/international-journal-of-educational-development/special-issue/1035CNWP9N3",
            children: "Special issue on learning profiles (open source) – International Journal of Educational Development (IJED)"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://mics.unicef.org/files?job=W1siZiIsIjIwMjAvMDUvMTIvMTgvMjUvNDUvNzAxLzIwXzA1XzA4X01JQ1NfR3VpZGVib29rX2NvbXByZXNzZWQucGRmIl1d&sha=6d386818d588d05c",
            children: "How to analyze MICS6 education data - UNICEF"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://riseprogramme.org/publications/descriptive-learning-trajectories-and-policy-simulations-using-mics6-data",
            children: "Simulations methodology – RISE"
          })
        }), "\n"]
      })
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
